var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardEnps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4511 31.6703V28.5055C18.4511 28.5055 20.8247 26.7648 20.8247 24.5494V22.4131",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.301 22.1758C10.301 22.1758 15.4439 17.2703 16.868 15.8461C18.2922 14.422 20.2702 17.6659 18.6087 19.8022C17.7384 20.6725 16.868 21.3846 16.868 21.3846C16.868 21.7011 16.868 22.6505 16.868 22.967C16.868 26.0527 14.0197 26.9231 13.545 26.9231",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8242 31.6703H5V38H20.8242V31.6703Z",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16455 34.8352H8.95576",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5955 13.9472L8.95595 16.7956C7.84826 17.8241 7.37354 18.378 7.37354 19.9604V25.3406V31.6703",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.602 17.1121L9.74704 10.9407L18.1339 9.99121L22.0108 2L25.8086 9.99121L34.2745 10.9407L28.2613 17.3494L29.6064 25.3407L22.0108 21.8593L16.6306 24.3121",
    stroke: "#212C42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEnps);
export default __webpack_public_path__ + "static/media/dashboard_enps.c47e97c4fc389e17ed0391ddb8079522.svg";
export { ForwardRef as ReactComponent };